export type SearchParamPrimitive = string | number | boolean | null | undefined;

export type SearchParamMap = Record<string, SearchParamPrimitive>;

const normalizeSearchParamValue = (value: SearchParamPrimitive): string | null => {
    if (typeof value === 'undefined' || value === null) {
        return null;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed ? trimmed : null;
    }

    return String(value);
};

export const buildSearchParams = ({ base, values }: { base?: string | URLSearchParams; values: SearchParamMap }) => {
    const params = new URLSearchParams(base instanceof URLSearchParams ? base.toString() : (base ?? ''));

    Object.entries(values).forEach(([key, value]) => {
        const normalizedValue = normalizeSearchParamValue(value);

        if (normalizedValue === null) {
            params.delete(key);
            return;
        }

        params.set(key, normalizedValue);
    });

    return params;
};

export const buildPathWithSearch = ({ pathname, base, values }: { pathname: string; base?: string | URLSearchParams; values: SearchParamMap }) => {
    const params = buildSearchParams({
        base,
        values,
    });
    const search = params.toString();

    return search ? `${pathname}?${search}` : pathname;
};
